import { DAPI_HOST } from '../../config/index';

const getLocationConsentFormsUrl = (locationId: any) =>
  `${DAPI_HOST}/v1/location-consent-forms?location_id=${locationId}`;

export { getLocationConsentFormsUrl };
